export default __webpack_public_path__ + "static/media/img2.60d56aaa.jpg";